import { render, staticRenderFns } from "./ebuypay.vue?vue&type=template&id=199b5774&scoped=true"
import script from "./ebuypay.vue?vue&type=script&lang=js"
export * from "./ebuypay.vue?vue&type=script&lang=js"
import style0 from "./ebuypay.vue?vue&type=style&index=0&id=199b5774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199b5774",
  null
  
)

export default component.exports